<template>
	<div class="list">
		<div class="items">
			<div
				v-for="(item, index) in list"
				:key="index"
				@click.stop="select(item, index)"
			>
				<label>
					<input
						type="radio"
						class="radio-item"
						:name="`item-span-${id}`"
						:id="`${id}-${index}`"
						:ref="index === 0 ? 'firstAlt' : ''"
					/>
					<span v-if="labelText">{{ `${labelText} ${index + 1}` }}</span>
					<span v-else>{{ `${readPropPath(item, labelPath)}` }}</span>
				</label>
			</div>
		</div>
		<div v-if="useSlot" class="slot">
			<slot name="content"></slot>
		</div>
		<div v-else-if="control.selected !== undefined" class="mathjax-container">
			<iframe
				:srcdoc="
					`<script type='text/javascript' id='MathJax-script' async src='https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js'><\/script><script> MathJax = {tex: { inlineMath: [['$', '$'], ['\\(', '\\)']] }, svg: { fontCache: 'global'}}<\/script><div class='mathjax'>${readPropPath(
						list[control.selected],
						propPath
					)}</div><style> .mathjax{ font-size: 20px;} img {object-fit: contain; width: 100%;}; </style>`
				"
				class="iframe-box"
				frameborder="0"
			>
			</iframe>
		</div>
	</div>
</template>

<script>
import EventBus from '@/components/event-bus.js'
export default {
	name: 'ClickOptionLoadContent',
	props: [
		'id',
		'useSlot',
		'propPath',
		'list',
		'labelText',
		'labelPath',
		'emitEvent',
		'returnProp'
	],
	data () {
		return {
			control: {
				selected: undefined
			}
		}
	},
	methods: {
		readPropPath (obj, path = []) {
			let curObj = obj

			path.forEach(p => {
				// eslint-disable-next-line no-prototype-builtins
				if (curObj.hasOwnProperty(p)) curObj = curObj[p]
			})

			return curObj
		},
		select (obj, index) {
			this.control.selected = index
			if (this.$props.emitEvent) {
				EventBus.$emit(
					'selectItem',
					this.$props.returnProp ? obj[this.$props.returnProp] : obj
				)
			}
		}
	},
	mounted () {
		if (this.control.selected === undefined) {
			if (this.$refs.firstAlt !== undefined) {
				this.$refs.firstAlt.forEach((item, index) => {
					item.checked = true
				})
				this.control.selected = 0
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.list {
	.items {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		gap: 15px;
		align-items: center;
		user-select: none;
		margin: 20px 0;

		div {
			label {
				.radio-item {
					display: none;
					&:checked {
						& ~ span {
							background-color: #4f5c6b;
							color: white;
						}
					}
				}
				span {
					background-color: $inputs-color;
					font-size: $font-size;
					font-weight: $font-weight-default-bolder;
					padding: 10px 20px;
					border-radius: 7px;
					color: $font-color;
					cursor: pointer;
					&:hover {
						background-color: $inputs-color-hover;
					}
				}
			}
		}
	}
	.slot {
		min-height: 30px;
	}
	.text {
		padding: 5px;
		margin-top: 10px;
		border: solid 1px $inputs-color;
		color: $font-color;
	}

	.mathjax-container {
		display: flex;
		width: 100%;
		justify-content: center;
		align-items: center;
		border: solid 1px #f3f3f3;
	}

	.mathjaxview {
		padding: 8px;
		text-align: left;
		height: 50%;
		width: 100%;
		align-items: center;
		display: inherit;
		gap: 5px;
	}

	.iframe-box {
		display: flex;
		width: 100%;
		height: 300px;
		border: solid 1px #f3f3f3;
	}
}
</style>

<style>
img {
	max-width: 100%;
}
</style>
